import sliceCreator from '../../index.jsx';
import {CREATE_DISTRICT} from '../../../constants/index.jsx';
const _createDistrictAction = sliceCreator('CREATE_DISTRICT', CREATE_DISTRICT, 'post');

const { asyncAction: createDistrictAction, reducer, clearData: clearCreateDistrictAction } = _createDistrictAction;

export default reducer;

export {
    createDistrictAction,
    clearCreateDistrictAction
}